<template>
  <div class="w-full overflow-x-auto">
    <table class="table-auto text-white w-full">
      <thead>
        <tr class="border-b border-white/50">
          <th
            v-for="(column, index) in header_columns"
            :key="index"
            :class="[th_class, sortable_columns.includes(column) ? 'cursor-pointer' : '']"
            class="p-2 font-semibold text-xs uppercase text-left"
            @click="handleSort(column, index)"
          >
            <div class="flex items-center gap-2">
              {{ column }}
              <div v-if="sortable_columns.includes(column)" class="flex flex-col">
                <ChevronUpIcon
                  class="h-3 w-3"
                  :class="[
                    currentSort.column == column && currentSort.direction == 'asc'
                      ? 'text-white'
                      : 'text-white/50'
                  ]"
                />
                <ChevronDownIcon
                  class="h-3 w-3"
                  :class="[
                    currentSort.column == column && currentSort.direction == 'desc'
                      ? 'text-white'
                      : 'text-white/50'
                  ]"
                />
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref } from 'vue';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/vue/24/solid';

export default {
  name: "DinamicTable",
  components: {
    ChevronUpIcon,
    ChevronDownIcon
  },
  props: {
    header_columns: {
      type: Array,
      required: true,
    },
    th_class: {
      type: String,
      default: null,
    },
    sortable_columns: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: () => ({
        column: '',
        direction: ''
      })
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const currentSort = ref({
      column: props.modelValue.column || '',
      direction: props.modelValue.direction || ''
    });

    const handleSort = (column, index) => {
      if (!props.sortable_columns.includes(column)) return;

      if (currentSort.value.column == column) {
        // Toggle direction if same column
        if (currentSort.value.direction == 'asc') {
          currentSort.value.direction = 'desc';
        } else if (currentSort.value.direction == 'desc') {
          currentSort.value.direction = '';
          currentSort.value.column = '';
        } else {
          currentSort.value.direction = 'asc';
        }
      } else {
        // New column selected
        currentSort.value = {
          column: column,
          direction: 'asc'
        };
      }

      emit('update:modelValue', {
        column: currentSort.value.column,
        direction: currentSort.value.direction,
        columnIndex: index
      });
    };

    return {
      currentSort,
      handleSort
    };
  }
};
</script>

<style scoped>
table tbody tr td {
  padding: 0.5rem 0.25rem;
}
</style>